import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { EnergyCostOverviewSiteViewModel } from '../../energy-cost-overview-movable-panel.view-model';

@Component({
  selector: 'app-energy-cost-overview-legend',
  imports: [TranslatePipe],
  templateUrl: './energy-cost-overview-legend.component.html',
  host: { class: 'flex flex-col px-2 pt-4' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnergyCostOverviewLegendComponent {
  public readonly sites = input.required<EnergyCostOverviewSiteViewModel[]>();
  public readonly isEnergyAggregated = input(false);
}
